import PubSub from 'pubsub-js';
import { listen } from 'quicklink';
import LocomotiveScroll from 'locomotive-scroll';
import { gsap } from 'gsap';
import { Swiper } from 'swiper/bundle';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const preventDefault = (ev) => {
  ev.preventDefault();
};
const common = {
  init() {
    // because this is the only way to reference it in removeEventList...
    this.destroyBinded = this.destroy.bind(this);
    this.resetAnimsBinded = this.resetSlideAnims.bind(this);
    this.lscrollUpdateBinded = this.lscrollUpdate.bind(this);

    console.log('Common init');

    this.setUpListeners();
    // this.setUpSmoothScroll();
    this.setUpSlideAnims();
    this.setUpAboutSlider();
    // this.setUpPartnersSlider();

    // Mobile address bar triggers resize event which forces scrolltrigger
    // to jump at the end of the animation
    ScrollTrigger.config({
      autoRefreshEvents: 'DOMContentLoaded,load'
    });
  },

  setUpListeners() {
    PubSub.subscribe('page.transitionStart', this.destroyBinded);
    PubSub.subscribe('common.resetSlideAnims', this.resetAnimsBinded);

    document.querySelectorAll('.nav > .view')
      .forEach($btn => $btn.addEventListener('click', this.handleNavViewClick));

    document
      .querySelectorAll('.gallery_wrapper .thumbnail_wrapper:not(.disabled)')
      .forEach($btn => $btn.addEventListener('click', this.handleThumbClick));

    document
      .querySelectorAll('.gallery_wrapper .item_wrapper:not(.disabled)')
      .forEach($btn => $btn.addEventListener('click', this.handleListVidClick));

    document.getElementById('video_modal')
      .addEventListener('click', ev => {
        if (ev.target.closest('.close') !== null
        || ev.target.classList.contains('modal_wrapper')) {
          document
            .getElementById('video_modal')
            .classList.remove('active');

          document
            .getElementById('video_modal')
            .querySelector('.video').innerHTML = '';
        }
      });

    // quicklink init
    listen();
  },

  handleNavViewClick(ev) {
    const $el = ev.currentTarget;

    if (!$el.classList.contains('active')
    && $el.classList.contains('thumbnail')) {
      document
        .querySelector('.nav > .view.active')
        .classList.remove('active');

      $el.classList.add('active');

      document
        .querySelector('.gallery_wrapper > .view.active')
        .classList.remove('active');

      document
        .querySelector('.gallery_wrapper > .view.thumbnail')
        .classList.add('active');
    } else if (!$el.classList.contains('active')
    && $el.classList.contains('list')) {
      document
        .querySelector('.nav > .view.active')
        .classList.remove('active');

      $el.classList.add('active');

      document
        .querySelector('.gallery_wrapper > .view.active')
        .classList.remove('active');

      document
        .querySelector('.gallery_wrapper > .view.list')
        .classList.add('active');
    }

    ScrollTrigger.refresh();

    ev.preventDefault();
  },

  handleThumbClick(ev) {
    const $modal = document.getElementById('video_modal');
    const $el = ev.currentTarget;
    const $iframe = $el.dataset.vimeo.replace('&amp;app_id', '&amp;autoplay=1&amp;app_id');
    const $desc = $el.dataset.desc;

    $modal.querySelector('.video').innerHTML = $iframe;
    $modal.querySelector('.desc').innerHTML = $desc;

    $modal.classList.add('active');
  },

  handleListVidClick(ev) {
    const $view = document.querySelector('.gallery_wrapper > .view.list');
    const $el = ev.currentTarget;
    const $iframe = $el.dataset.vimeo.replace('&amp;app_id', '&amp;autoplay=1&amp;app_id');
    const $desc = $el.dataset.desc;

    $view
      .querySelector('.theater_wrapper > .video_wrapper')
      .innerHTML = $iframe;

    $view
      .querySelector('.info_wrapper > .desc')
      .innerHTML = $desc;
  },

  resetSlideAnims() {
    this.destroySlideAnims();
    this.setUpSlideAnims();
  },

  setUpSmoothScroll() {
    const that = this;
    const isMobile = window.innerWidth <= 767;

    if (!this.lscroll && !isMobile) {
      this.lscroll = new LocomotiveScroll({
        el: document.getElementById('app'),
        smooth: true,
        initPosition: {x: 0, y: 0},
        reloadOnContextChange: true,
        resetNativeScroll: true,
        smartphone: {
          smooth: false
        }
      });

      this.lscroll.on('scroll', ScrollTrigger.update);

      ScrollTrigger.scrollerProxy('#app', {
        scrollTop(value) {
          return arguments.length
            ? that.lscroll.scrollTo(value, 0, 0)
            : that.lscroll.scroll.instance.scroll.y;
        },

        getBoundingClientRect() {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight
          };
        },

        pinType: document.getElementById('app').style.transform
          ? 'transform'
          : 'fixed'
      });

      ScrollTrigger.addEventListener('refresh', this.lscrollUpdateBinded);

      ScrollTrigger.refresh();

      setTimeout(() => {
        this.lscrollUpdate();
      }, 1000);
    } else if (!isMobile) {
      this.lscroll.init();

      setTimeout(() => {
        this.lscrollUpdate();
      }, 1000);
    }
  },

  lscrollUpdate() {
    if (this.lscroll && this.lscroll.update) {
      this.lscroll.update();
    }
  },

  setUpSlideAnims() {
    console.log('Setting up slide in animations');

    ScrollTrigger.batch(
      '.slide-in,'
      + ' .text-in > p,'
      + ' .text-in > h1,'
      + ' .text-in > h2,'
      + ' .text-in > h3,'
      + ' .text-in > h4,'
      + ' .text-in > h5,'
      + ' .text-in > ul,'
      + ' .text-in > ol,'
      + ' .text-in > .wp-caption,'
      + ' .text-in > blockquote',
      {
        id: 'slide_in',
        // scroller: window.innerWidth > 767 ? '#app' : window,
        batchMax: window.innerWidth > 767 ? 15 : 5,
        interval: 0.2, // time window (in seconds) for batching to occur.
        fastScrollEnd: true,
        preventOverlaps: true,
        onEnter: batch => gsap.to(batch, {
          duration: 2,
          ease: 'expo.out',
          x: 0, y: 0,
          rotation: 0,
          opacity: 1,
          stagger: 0.2,
          overwrite: true
        })
      });
  },

  setUpAboutSlider() {
    new Swiper(document.querySelector('.content_slider'), {
      fadeEffect: {
        crossFade: true
      },
      effect: 'fade',
      autoplay: {
        delay: 10000,
      },
      loop: true,
      speed: 1000,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
  },

  setUpPartnersSlider() {
    new Swiper(document.querySelector('.partners_slider'), {
      fadeEffect: {
        crossFade: true
      },
      effect: 'fade',
      autoplay: {
        delay: 10000,
      },
      loop: true,
      speed: 500,
      slidesPerView: 1,
      pagination: {
        el: '.partners-swiper-pagination',
        clickable: true,
        dynamicBullets: true
      },
      navigation: {
        nextEl: '.partners-swiper-button-next',
        prevEl: '.partners-swiper-button-prev',
      },
      on: {
        // eslint-disable-next-line id-length
        slideChangeTransitionStart: swiper => {
          const $nextSlide = swiper.slides[swiper.activeIndex];

          document
            .querySelector('.partners_wrapper > .logo_preview')
            .innerHTML = $nextSlide.querySelector('.logo > .logo').innerHTML;
        }
      }
    });
  },

  destroySlideAnims() {
    const triggers = ScrollTrigger.getAll();

    triggers.forEach(trigger => {
      if (trigger.vars.id === 'slide_in') {
        trigger.kill();
        console.log('Destroying slide_in triggers');
      }
    });

    ScrollTrigger.refresh();
  },

  destroy() {
    PubSub.unsubscribe('page.transitionStart', this.destroyBinded);
    PubSub.unsubscribe('common.resetSlideAnims', this.resetAnimsBinded);

    if (this.lscroll) {
      this.lscroll.destroy();
    }
    this.destroySlideAnims();
  }
};

PubSub.subscribe('page.inDOM', common.init.bind(common));

export default common;
